<template>
  <span :class="['label', `label-pricerequest-status-${status}`]">{{status | formatLookupName(PricingRequestStatusTypeLookup)}}</span>
</template>

<script>
import { PricingRequestStatusTypeLookup } from '@/store/types'
export default {
  name: 'LabelPriceRequestStatusBadge',
  props: {
    status: String
  },
  created() {
    this.PricingRequestStatusTypeLookup = PricingRequestStatusTypeLookup
  }  
}
</script>